import { makeStyle } from '../../../../utils';
import { subTitle2, blackHigh, blackOutline, blackMedium, subTitle1, caption, button } from '../../../../resources/styles';

const styles = {};

styles['container'] = makeStyle({
    padding: '16px 32px',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});

styles['person'] = makeStyle({
    backgroundColor: blackOutline.color,
    color: 'white',
    borderRadius: 24,
    fontSize: 28,
    padding: 10,
});

styles['name'] = makeStyle({
    ...subTitle1,
    ...blackHigh,
    marginTop: 8,
});

styles['number'] = makeStyle({
    ...caption,
    ...blackMedium,
    letterSpacing: '0.2px',
    marginTop: 4,
});

styles['ripple'] = makeStyle({
    marginTop: 16,
    borderRadius: 6,
    color: '#2298DA',
});

styles['signout_ripple'] = makeStyle({
    marginTop: 16,
    borderRadius: 6,
    color: 'var(--theme-color)',
});

styles['button'] = makeStyle({
    width: 232,
    borderRadius: 6,
    padding: '8px 0',
    cursor: 'pointer',
    border: '1px solid rgba(34, 152, 218, 0.2)',
    ...button,
    textAlign: 'center',
});

export default styles;